module.exports = __webpack_public_path__ + "img/flags_responsive.73e6b012.png";